import { http } from '../../../axios';
import { libxConfig } from '../../../../config';
import { AgeCategory } from '../../../../../models/AgeCategory';
import { Level1Out } from '../../../../store/apiLibx';

export function fetchLocalRegions(ageCategory: AgeCategory) {
    return http
        .get<{ level1: Level1Out[] }>(libxConfig().endpointLocalRegions, {
            params: {
                ageCategory: ageCategory !== AgeCategory.ALL_AGES ? ageCategory : undefined
            }
        })
        .then(response => response.data);
}
